import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import styles from '../component-styles/custom-cause-input.module.scss'
import { Label, ClickEditInput } from './input'
import {
  updateAnomalyDescription,
  // setAnomalyAsSeen,
  // setAnomalyAsNotSeen,
} from '../store/actions'

interface Props {
  viewOnly?: boolean
}

export default function CustomCauseInput({
  viewOnly = false,
}: Props): React.ReactElement {
  const dispatch = useDispatch()
  const { anomaly } = useSelector((s: any): any => s)

  const {
    userSuppliedCause,
    userSuppliedAction,
    userSuppliedEffort,
    userSuppliedBenefit,
    anomalyDateID,
  } = anomaly?.description || {}

  const updateStatus = (anom: any) => {
    if (anomaly && anomaly.description !== null) {
      const data = { ...anomaly.description, ...anom }
      const {
        userSuppliedCause: a = '',
        userSuppliedAction: b = '',
        userSuppliedEffort: c = '',
        userSuppliedBenefit: d = '',
      } = data

      dispatch(
        updateAnomalyDescription({
          ...data,
          explainedAnomaly: `${a}${b}${c}${d}` !== '',
        }),
      )
    }
  }

  return (
    <div className={styles.form} key={anomalyDateID}>
      {!(viewOnly && userSuppliedCause === '') && (
        <>
          <Label className={styles.label} id="message">
            What happened
          </Label>
          <ClickEditInput
            id="message"
            viewOnly={viewOnly}
            onChange={(val: string): void => {
              updateStatus({
                userSuppliedCause: val,
              })
            }}
            value={userSuppliedCause}
            type="textArea"
            placeholder={
              viewOnly && userSuppliedCause === ''
                ? 'N/A'
                : 'Explained what happened in the anomaly here...'
            }
          />
        </>
      )}
      {!(viewOnly && userSuppliedAction === '') && (
        <>
          <Label className={styles.label} id="explain">
            What to do next
          </Label>
          <ClickEditInput
            id="explain"
            viewOnly={viewOnly}
            onChange={(val: string): void => {
              updateStatus({
                userSuppliedAction: val,
              })
            }}
            value={userSuppliedAction}
            type="textArea"
            placeholder={
              viewOnly && userSuppliedAction === ''
                ? 'N/A'
                : 'Explained what to do next...'
            }
          />
        </>
      )}
      <div className={styles.twoColumns}>
        {!(viewOnly && userSuppliedBenefit === '') && (
          <div>
            <Label className={styles.label} id="benefit">
              Benefit
            </Label>
            <ClickEditInput
              className={styles.input}
              id="benefit"
              viewOnly={viewOnly}
              onChange={(val: string): void => {
                updateStatus({
                  userSuppliedBenefit: val,
                })
              }}
              value={userSuppliedBenefit}
              type="text"
              // inputWhenEmpty
              placeholder={
                viewOnly && userSuppliedBenefit === ''
                  ? 'N/A'
                  : 'Please add benefit required...'
              }
            />
          </div>
        )}
        {!(viewOnly && userSuppliedEffort === '') && (
          <div>
            <Label className={styles.label} id="effort">
              Effort
            </Label>
            <ClickEditInput
              className={styles.input}
              id="effort"
              viewOnly={viewOnly}
              onChange={(val: string): void => {
                updateStatus({
                  userSuppliedEffort: val,
                })
              }}
              value={userSuppliedEffort}
              type="text"
              // inputWhenEmpty
              placeholder={
                viewOnly && userSuppliedEffort === ''
                  ? 'N/A'
                  : 'Please add effort required...'
              }
            />
          </div>
        )}
      </div>
    </div>
  )
}
